//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'spatial01',
    colors: ['#ff5937', '#f6f6f4', '#4169ff'],
    stroke: '#ff5937',
    background: '#f6f6f4',
    type: 'spatial',
  },
  {
    name: 'spatial02',
    colors: ['#ff5937', '#f6f6f4', '#f6f6f4'],
    stroke: '#ff5937',
    background: '#f6f6f4',
    type: 'spatial',
  },
  {
    name: 'spatial02i',
    colors: ['#f6f6f4', '#ff5937', '#ff5937'],
    stroke: '#f6f6f4',
    background: '#ff5937',
    type: 'spatial',
  },

  {
    name: 'spatial03',
    colors: ['#4169ff', '#f6f6f4', '#f6f6f4'],
    stroke: '#4169ff',
    background: '#f6f6f4',
    type: 'spatial',
  },
  {
    name: 'spatial03i',
    colors: ['#f6f6f4', '#4169ff', '#4169ff'],
    stroke: '#f6f6f4',
    background: '#4169ff',
    type: 'spatial',
  },
];
